<div>
  <audio controls [controlsList]="'nodownload'" [src]="audio_url" #audioElem></audio>
</div>
